import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { usePriceContext } from "@/components/Price/context/price.context";
import { formatPrice } from "@/utils/price.utils";

type Props = {
    className?: string;
};

export const StrikeThrough = ({ className }: Props) => {
    const { strikeThroughPrice, size } = usePriceContext();

    const formattedPrice = isDefined(strikeThroughPrice)
        ? formatPrice(strikeThroughPrice)
        : "";

    return (
        <span
            className={cn(
                "tw:relative tw:block tw:w-fit",
                {
                    "tw:text-xs tw:min-h-3.5 tw:leading-3.5":
                        size === "sm" || size === "xs",
                    "tw:min-h-4.5 tw:text-sm tw:leading-4.5": size === "md",
                    "tw:min-h-5 tw:leading-5": size === "lg",
                    "tw:min-h-6 tw:leading-6": size === "xl"
                },
                "tw:before:content-[''] tw:before:absolute tw:before:left-0 tw:before:w-full tw:before:top-[45%] tw:before:border-t-[0.0625em] tw:before:border-inherit tw:before:skew-y-10",
                className
            )}
        >
            {formattedPrice}
        </span>
    );
};
